import { CommonConstant } from "@/utils/enum";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BulkUploadState {
  item: any | null;
  venue_school: any | null;
}

const initialState: BulkUploadState = {
  item: null,
  venue_school: null,
};

const bulkUploadSlice = createSlice({
  name: CommonConstant.BULKUPLOAD,
  initialState,
  reducers: {
    setItem: (state, action: PayloadAction<any>) => {
      state.item = action.payload;
    },
    removeItem: (state) => {
      state.item = null;
    },
    setVenueSchool: (state, action: PayloadAction<any>) => {
      state.venue_school = action.payload;
    },
    clearVenueSchool: (state) => {
      state.venue_school = null;
    },
  },
});

export const { setItem, removeItem, setVenueSchool, clearVenueSchool } =
  bulkUploadSlice.actions;

export default bulkUploadSlice.reducer;

export const selectItem = (state: { bulkUpload: BulkUploadState }) =>
  state.bulkUpload.item;
